<div class="card position-relative px-2">
  <div class="pt-2 template3_tab d-flex align-items-center justify-content-between gap-2 px-2">
    <div>
      <ul class="nav template3_nav nav-tabs border-0">
        <li class="nav-item" *ngFor="let tab of tab; let sr = index" (click)="setTab(sr)">
          <a class="nav-link" [ngClass]="activatedTab == sr ? 'active' : ''">{{ tab }}</a>
        </li>
      </ul>
    </div>
    <div class="d-flex align-items-center">
      <span class="text-muted" *ngIf="checkSibling(selfAssessmentId, 'Previous')">
        <span class="text-blue float-right" (click)="getSiblings('Previous')">Previous</span>
      </span>
      <span class="text-muted" *ngIf="checkSibling(selfAssessmentId, 'Next')">
        <span class="text-blue mr-2 ml-2 float-right" (click)="getSiblings('Next')">Next</span>
      </span>

      <span class="cursor-pointer text-primary mr-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="sendNotification()"
          *ngIf="!selftassessmentSummary.isSendNotification" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="sendNotification()"
          *ngIf="selftassessmentSummary.isSendNotification" aria-hidden="true"></i>
        Send Notification
      </span>
      <span class="cursor-pointer text-primary mr-2">
        <i class="fa fa-square-o icon-font vertical-align-middle" (click)="updateRecordTime()"
          *ngIf="!selftassessmentSummary.isRecordTime" aria-hidden="true"></i>
        <i class="fa fa-check-square icon-font vertical-align-middle" (click)="updateRecordTime()"
          *ngIf="selftassessmentSummary.isRecordTime" aria-hidden="true"></i>
        Record Time
      </span>
      <div class="fixed-bar-sticky-t3Nav" (scroll)="onScroll()" [ngClass]="fixedBar ? 'fixed': '' "
        *ngIf="logedInUserList.length > 0">
        <div class="d-flex justify-content-end">
          <div class="fixed-bar mr-1 align-items-center">
            <div class="user_online">
              <span *ngFor="let item of logedInUserList"> <i class="fa fa-circle text-success mr-1"
                  aria-hidden="true"></i>
                {{ item.UserName }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-2 position-relative">
    <div class="tab-content shadow-none border-0 py-1 px-2">
      <div *ngIf="activatedTabIndex == 0">
        <app-summary-t3 [selfAssessmentId]="selfAssessmentId"
          [selfassessmentSummaryFromParent]="selftassessmentSummary"> </app-summary-t3>
      </div>
      <div *ngIf="activatedTabIndex == 1">
        <app-key-information [selfAssessmentId]="selfAssessmentId"></app-key-information>
      </div>
      <div *ngIf="activatedTabIndex == 2">
        <app-self-assessment-template3-overall-assessment [summaryDetailsId]="selfAssessmentId"
          (notifyCkEditorChange)="onNotifyCkeditorChange($event)"></app-self-assessment-template3-overall-assessment>
      </div>
      <div *ngIf="activatedTabIndex == 3">
        <app-interpretations-t3 (notifyCkEditorChange)="onNotifyCkeditorChange($event)"
          [summaryDetailsId]="selfAssessmentId"></app-interpretations-t3>
      </div>
      <div *ngIf="activatedTabIndex == 4">
        <app-judgment-t3 (notifyCkEditorChange)="onNotifyCkeditorChange($event)"
          [summaryDetailsId]="selfAssessmentId"></app-judgment-t3>
      </div>
      <div *ngIf="activatedTabIndex == 5">
        <app-approach-t3 (notifyCkEditorChange)="onNotifyCkeditorChange($event)"
          [summaryDetailsId]="selfAssessmentId"></app-approach-t3>
      </div>
    </div>
  </div>
</div>